import React from "react";
import PropTypes from "prop-types";

import styled from "styled-components";
import { Link as RLink } from "react-router-dom";
import { K_COLORS_SMOKE_GREY, K_COLORS_WHITE } from "constants.js";

const RouterLink = styled(RLink)`
  &,color: ${K_COLORS_WHITE};
  text-decoration: underline;
  text-decoration-color: ${K_COLORS_SMOKE_GREY};

  &:visited {
    color: ${K_COLORS_WHITE};
    text-decoration-color: ${K_COLORS_SMOKE_GREY};
  }

  &:hover {
    text-decoration-color: ${K_COLORS_WHITE};
    transition: text-decoration 0.3s ease-out;
  }
`;

const Link = (props) => {
  const { label, target, style } = props;

  return (
    <RouterLink to={target} style={style}>
      {label}
    </RouterLink>
  );
};

Link.propTypes = {
  label: PropTypes.string.isRequired,
  target: PropTypes.string.isRequired,
  style: PropTypes.string.isRequired,
};

export default Link;
